/* -- Page Transition: Motion Blur Zoom -- */
(function () {
  var overlay = document.createElement('div');
  overlay.id = 'page-transition';
  overlay.innerHTML = '<div class="pt-blur-layer"></div><div class="pt-flash"></div>';
  document.body.appendChild(overlay);

  var style = document.createElement('style');
  style.textContent = '#page-transition { position: fixed; inset: 0; z-index: 99999; pointer-events: none; opacity: 0; transition: opacity 0.3s ease; } #page-transition.active { opacity: 1; pointer-events: all; } .pt-blur-layer { position: absolute; inset: 0; backdrop-filter: blur(0px); -webkit-backdrop-filter: blur(0px); transition: backdrop-filter 0.8s ease, -webkit-backdrop-filter 0.8s ease; } #page-transition.active .pt-blur-layer { backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); } .pt-flash { position: absolute; inset: 0; background: #000; opacity: 0; transition: opacity 0.6s ease 0.4s; } #page-transition.active .pt-flash { opacity: 1; } body.page-zooming { transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1); transform: scale(1.15); transform-origin: center center; }';
  document.head.appendChild(style);

  document.addEventListener('click', function(e) {
    var card = e.target.closest('.wc-product-card, .product-card-wrapper a');
    if (!card) return;

    e.preventDefault();
    var href = card.getAttribute('href');
    if (!href) return;

    var rect = card.getBoundingClientRect();
    var x = rect.left + rect.width / 2;
    var y = rect.top + rect.height / 2;
    document.body.style.transformOrigin = x + 'px ' + y + 'px';

    document.body.classList.add('page-zooming');
    overlay.classList.add('active');

    setTimeout(function() {
      window.location.href = href;
    }, 900);
  });
})();